export const countVehiclesInspectedDailyService =
  (fetch) =>
  async ({ filters }) => {
    try {
      const searchParams = new URLSearchParams(filters).toString();
      const response = await fetch({
        url: `/api/v1/inspeccion-vehiculos/contar-vehiculos-inspeccionados-diarios?${searchParams}`,
      });

      return response;
    } catch (error) {
      throw new Error(error.response?.data?.message || error.message);
    }
  };
